<template>
  <v-card>
  <v-form @submit.prevent="updateTrainer" novalidate>
    <v-toolbar flat dense dark color="primary">
      <v-toolbar-title>{{ trainer.full_name }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="accent" small @click.prevent="updateMode = !updateMode">edytuj</v-btn>
      <v-btn color="light-blue darken-3" v-if="isSelf" small :to="{name: 'trainer-change-password'}">zmień hasło</v-btn>
    </v-toolbar>
    <v-layout row wrap>
      <v-flex xs12 sm6 md4 lg3 class="text-xs-center mt-5">
        <div role="group" v-if="updateMode">
          <picture-input
            ref="pictureInput"
            @change="changeAvatar"
            width="200"
            height="200"
            margin="8"
            size="10"
            buttonClass="btn btn-outline-secondary"
            :customStrings="{
              upload: '<p>Urządzenie nie obsługiwane.</p>',
              drag: 'Upuść plik lub <br/>kliknij aby wybrać',
              change: 'Zmień obraz',
              remove: 'Usuń obraz',
              select: 'Wybierz obraz',
              selected: '<p>Photo successfully selected!</p>',
              fileSize: 'The file size exceeds the limit',
              fileType: 'This file type is not supported.',
              aspect: 'Landscape/Portrait'
            }">
          </picture-input>
        </div>
        <img width="200" v-if="!updateMode && trainer.avatar_thumbnail" class="d-inline-block avatar" id="avatar_thumbnailInput" :src="trainer.avatar_thumbnail" />
        <img width="200" v-if="!updateMode && !trainer.avatar_thumbnail" class="d-inline-block avatar" id="avatar_thumbnailInput" src="@/assets/img/avatar.png" />
      </v-flex>
      <v-flex xs12 sm6 md5 lg4>
        <v-list class="personal-fields" two-line>
          <runner-data-field
            :editable="updateMode"
            label="Imię"
            required
            v-model="form.first_name"
            :objValue="trainer.first_name"
            :formErrors="formErrors"
            :field="'first_name'"></runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Nazwisko"
            required
            v-model="form.last_name"
            :objValue="trainer.last_name"
            :formErrors="formErrors"
            :field="'last_name'"></runner-data-field>
          <runner-data-field
            :editable="updateMode"
            label="Telefon"
            v-model="form.phone"
            :objValue="trainer.phone"
            :formErrors="formErrors"
            :field="'phone'">
            <a :href="'tel:' + trainer.phone" slot="value">{{trainer.phone}}</a>
          </runner-data-field>
            <v-list-tile  @click="">
              <v-list-tile-content>
                <v-list-tile-sub-title >Email</v-list-tile-sub-title>
                <v-list-tile-title><a :href="'mailto:' + trainer.email">{{trainer.email}}</a></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg0>
        <v-list class="personal-fields mt-2" two-line>
          <runner-data-field
            :class="{bigger: updateMode}"
            :editable="updateMode"
            label="O sobie"
            v-model="form.about"
            :objValue="trainer.about"
            :formErrors="formErrors"
            :field="'about'">

              <template slot-scope="{ error, errorMessages, label }">
                <v-textarea
                              :label="label"
                              v-model="form.about"
                              :error="error"
                              :error-messages="errorMessages"
                              auto-grow
                />
              </template>
          </runner-data-field>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 sm6 md5 lg4 offset-sm6 offset-md4 offset-lg3>
        <v-btn v-if="updateMode" type="submit" color="primary">Zapisz</v-btn>
      </v-flex>
    </v-layout>
  </v-form>
  </v-card>
</template>

<script>
import {updateTrainer, getTrainer} from './api'
import {Validator} from 'simple-vue-validator'
import {serverValidation} from '@/utils/form-utils'
import iziToast from 'izitoast'
import PictureInput from 'vue-picture-input'
import { mapGetters } from 'vuex'
import RunnerDataField from '../runners/RunnerDataField'

export default {
  components: {PictureInput, RunnerDataField},
  validators: {
    'runner.avatar_thumbnail': function (value) {
      value = value || null
      return Validator.value(value).custom(serverValidation(this.formErrors, 'avatar_thumbnail'))
    }
  },
  data () {
    return {
      updateMode: false,
      form: {},
      formErrors: {},
      trainer: {}
    }
  },
  computed: {
    ...mapGetters(['authUser']),
    isSelf: function () {
      return parseInt(this.$route.params.id) === this.authUser.id
    }
  },
  watch: {
    '$route': 'fetchTrainer'
  },
  mounted () {
    this.fetchTrainer()
  },
  methods: {
    fetchTrainer () {
      getTrainer(this.$route.params.id).then((data) => {
        this.trainer = data
        this.form = {...this.trainer}
      })
    },
    changeAvatar (image) {
      this.form.avatar_thumbnail = this.$refs.pictureInput.file
    },
    updateTrainer () {
      this.$validate().then(success => {
        if (success) {
          updateTrainer(this.form).then((data) => {
            this.validation.reset()
            this.$emit('trainer-updated', data)
            iziToast.show({
              message: 'Konto trenera zostało edytowane.',
              color: 'green'
            })
            this.updateMode = false
            this.trainer = data
            return data
          }).catch((data) => {
            if (data.response.status === 400) {
              this.formErrors = data.response.data
              this.$validate()
            }
          })
        }
      })
    }
  }
}
</script>
<style>
.personal-fields .v-list__tile--link.v-list__tile {
  min-height: 72px;
  height: auto;
}
.personal-fields .v-list__tile__content {
  min-height: 72px;
  height: auto;
}
.personal-fields .v-list__tile__title {
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/trainers/TrainerData.vue